/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
import { Heading } from 'sarsaparilla';
import orderBy from 'lodash/orderBy';
import { TreePermitData } from 'ui-tree-permit/types/permit';

interface ContactType {
    content: TreePermitData['contact_us'];
}
export default function Contact({ content = [] }: ContactType) {
    const contentSorted = orderBy(
        content.map((item) => {
            return {
                ...item,
                name: item?.name?.trim(),
            };
        }),
        ['name'],
        ['asc']
    );

    return (
        <div className="tp-contact">
            {contentSorted?.map((item, i) => {
                const addressItems = [];

                if (item?.city) {
                    addressItems.push(`${item?.city},`);
                }
                if (item?.state) {
                    addressItems.push(item?.state);
                }
                if (item?.zipcode) {
                    addressItems.push(item?.zipcode);
                }

                const addressLine = addressItems.join(' ');

                return (
                    <div className="tp-contact-item" key={i}>
                        <Heading
                            headingLevel={3}
                            appearance="h5"
                            className="tp-contact-title"
                        >
                            {item?.name}
                        </Heading>
                        <div className="tp-contact-content">
                            {item?.email && (
                                <div className="tp-contact-email">
                                    <a href={`mailto:${item?.email}`}>{item?.email}</a>
                                </div>
                            )}
                            {(item?.address || addressLine) && (
                                <div className="tp-contact-address">
                                    {item?.address && <div>{item?.address}</div>}
                                    {addressLine && <div>{addressLine}</div>}
                                </div>
                            )}
                            {item?.phone_number && (
                                <div className="tp-contact-phone">
                                    {item?.phone_number}
                                </div>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
